import React from "react";
import { Polygon, Circle } from "react-leaflet";
import L from "leaflet";

/**
 * Компонент для отображения сектора покрытия Wi-Fi AP и Station
 * item: объект Wi-Fi точки
 * index: индекс для ключа
 */
const WifiCoverageSector = ({ item, index }) => {
  if (
    !(item.wifiTypeId === 1 || item.wifiTypeId === 3) ||
    !item.horAngleDeg ||
    !item.radius ||
    item.latitude === undefined ||
    item.longitude === undefined
  ) {
    return null;
  }

  const center = L.latLng(item.latitude, item.longitude);
  const azimuth = item.azimuth ?? 0;
  const halfAngle = item.horAngleDeg / 2;
  const step = 5;

  // Если полный круг → используем Circle
  if (item.horAngleDeg >= 360) {
    return (
      <Circle
        key={`wifi-circle-${index}`}
        center={center}
        radius={item.radius} // тут можно напрямую метры
        pathOptions={{
          color: item.wifiTypeId === 1 ? "#a18403ff" : "#4b027cff",
          fillColor: item.wifiTypeId === 1 ? "#ddb606ff" : "#770bbeff",
          fillOpacity: 0.2,
          weight: 1,
        }}
      />
    );
  }

  // Иначе рисуем сектор
  const points = [[center.lat, center.lng]];

  for (let a = -halfAngle; a <= halfAngle; a += step) {
    const angleDeg = azimuth + a;
    const angleRad = (angleDeg * Math.PI) / 180;

    const latOffset = (item.radius / 111320) * Math.cos(angleRad);
    const lngOffset =
      (item.radius / (40075000 * Math.cos((center.lat * Math.PI) / 180) / 360)) *
      Math.sin(angleRad);

    points.push([center.lat + latOffset, center.lng + lngOffset]);
  }

  points.push([center.lat, center.lng]);

  return (
    <Polygon
      key={`wifi-sector-${index}`}
      positions={points}
      pathOptions={{
        color: item.wifiTypeId === 1 ? "#a18403ff" : "#4b027cff",
        fillColor: item.wifiTypeId === 1 ? "#ddb606ff" : "#770bbeff",
        fillOpacity: 0.2,
        weight: 1,
      }}
    />
  );
};

export default WifiCoverageSector;